import React, { useState, useRef, useEffect, useCallback } from "react";
import 'ag-grid-enterprise';
import AgGridTable from "../utilities/AgGridTable";
import Select from "react-select";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Autocomplete, Button, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import moment from 'moment';
import CustomDatePicker from "../utilities/CustomDatePicker";
const initialValue = {
    employeeName: null,
    startDate: null,
    endDate: null
}

// var filterParams = {
//     comparator: (filterLocalDateAtMidnight, cellValue) => {
//         if (cellValue === null) return 0;
//         const cellDate = cellValue;
//         const filterDateFormat = moment(filterLocalDateAtMidnight).format("YYYY-MM-DD");
//         return cellDate < filterDateFormat ? -1 : cellDate > filterDateFormat ? 1 : 0;
//     },
//     // minValidYear: 2000,
//     // inRangeInclusive : true,
//     // dateFormat : "YYYY-MM-DD",
//     // inRangeFloatingFilterDateFormat: "YYYY-MM-DD",
// };

const Attendance = () => {
    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.attendance}`;
    const findAttendanceUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.findAttendance}`;
    const perPage = 10;
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const [error, setError] = useState("")
    const gridRef = useRef();
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [searchType, setSearchType] = useState("byDate");
    const navigate = useNavigate();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [employee, setEmployee] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [byemployee, setByemployee] = useState();

    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }

    const [columnDefs, setColumnDefs] = useState([
        { field: 'employeeId', enableRowGroup: true, },
        { field: 'employeeName', enableRowGroup: true, },
        { field: 'department', enableRowGroup: true, },
        { field: 'attendanceCategory', enableRowGroup: true, },
        { field: 'attendanceDuration', enableRowGroup: true, },
        { field: 'logDate', enableRowGroup: true, cellRenderer: handleDateFormat},
        { field: 'logTimeIn', enableRowGroup: true, },
        { field: 'logTimeOut', enableRowGroup: true, },

    ]);

    const [searchBy, setSearchBy] = useState(initialValue)

    const searchOption = [
        { value: "byDate", label: "Date" },
        { value: "byEmployeeName", label: "Name" }
    ]

    const getAttendance = async () => {
        try {
            const res = await OAuthService.getList(url + '?sort=cityName,asc&size=1000');
            let attendanceInfoes = res.data._embedded.attendanceInfoes;
            attendanceInfoes = attendanceInfoes.map((attendance) => {

                const logTimeIn = moment(attendance.logTimeIn).format('hh:mm A');
                const logTimeOut = moment(attendance.logTimeOut).format('hh:mm A');
                attendance.logTimeIn = logTimeIn;
                attendance.logTimeOut = logTimeOut;
                return attendance;

            });
            const currentDate = new Date();
            const threeMonthsData = new Date();
            threeMonthsData.setMonth(currentDate.getMonth() - 3);
            const filteredRecords = attendanceInfoes.filter((attendance) => {
                const recordDate = new Date(attendance.logDate);
                return recordDate >= threeMonthsData && recordDate <= currentDate;
            });
            setEmployee(filteredRecords);
            setRowData(filteredRecords);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    useEffect(() => {
        getAttendance();
    }, [searchType]);
    


    const onGridReady = useCallback((params) => {
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'Attendance.xlsx',
            sheetName: 'Attendance'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully");
                setSnackState(true);
                getAttendance();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onRowDoubleClicked = (params) => {
        navigate('/editAttendance/' + selectedRows[0]?.id)
    }

    const handleSearchTypeChange = (data) => {
        setSearchType(data.value);
        setSearchBy(initialValue);
    }

    // const handleChange = (event, key) => {
    //     let startDate;
    //     let endDate;
    //     if (key === "startDate") {
    //         startDate = moment(event).format('YYYY-MM-DD')
    //         setSearchBy({ ...searchBy, startDate: startDate });
    //         handleSearch(startDate,endDate);
    //     }else if(key === "endDate"){
    //         endDate = moment(event).format('YYYY-MM-DD');
    //         setSearchBy({ ...searchBy, endDate: endDate });
    //         handleSearch(startDate, endDate);
    //     }
    //     else {
    //         setSearchBy({ ...searchBy, [event.target.name]: event.target.value })
    //     }
    // }

    const handleStartDateChange = (value) => {
        const date = value === null ? null : moment(value).format('YYYY-MM-DD')
        setStartDate(value === null ? null : date);
        // date && setEndDate(null);
        handleSearch(date, endDate);
    }

    const handleEndDateChange = (value) => {
        const date = value === null ? null : moment(value).format('YYYY-MM-DD');
        setEndDate(date);
        handleSearch(startDate, date);
    }

    const handleEmployeeChange = (event,value) => {
        console.log('value', value)
        setByemployee(value);
        handleSearch(startDate, endDate, value);
    }

    const handleSearch = async (startDate, endDate, employee) => {
        try {
            const model = {
                employeeName : employee,
                startDate : startDate,
                endDate : endDate
            }
            if(startDate && endDate || employee){
                const res = await OAuthService.addData(findAttendanceUrl, model);
                if (res.status === 200) {
                    let attendanceInfo = res.data;
                    attendanceInfo = attendanceInfo.map((attendance) => {
                        const logTimeIn = moment(attendance.logTimeIn).format('hh:mm A');
                        const logTimeOut = moment(attendance.logTimeOut).format('hh:mm A');
                        attendance.logTimeIn = logTimeIn;
                        attendance.logTimeOut = logTimeOut;
                        return attendance;
                    })
                    setRowData(attendanceInfo);
                } else {
                    setRowData([])
                }
            }
        } catch (error) {
            setError(error.message);
        }
    }

    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows]);


    /*------------------------------------------------------------------------*/

    const headerInputFields = () => {

        return (
            <>
            <div className="flex items-center">

                <label>Search By</label>
                <Select name="searchType"
                    value={(searchType && searchOption) && searchOption.filter(obj => searchType.includes(obj.value))}
                    onChange={handleSearchTypeChange}
                    className="w-[140px]"
                    options={searchOption}
                    styles={customStyles()}
                />
            </div>

                {searchType === "byDate" ?
                    <>
                    <div className="flex items-center">
                        <label>Start Date:</label>
                        <div className="grid">
                            {/* <CustomDatePicker
                                className="w-[170px]"
                                format={'dd-MM-yyyy'}
                                name={'startDate'}
                                value={searchBy.startDate}
                                maxDate={new Date()}
                                handleChange={(e) => handleChange(e, "startDate")}
                            /> */}
                            <CustomDatePicker
                                className="w-[170px]"
                                format={'dd-MM-yyyy'}
                                name={'startDate'}
                                value={startDate}
                                handleChange={handleStartDateChange}
                                componentsProps={{
                                    actionBar: { actions: ["clear"] },
                                }}
                                renderInput={(params) => <TextField size="small" InputLabelProps={{
                                }} {...params}/>}
                            />
                        </div>

                    </div>
                    <div className="flex items-center">
                        <label>End Date:</label>
                        <div className="grid">
                            {/* <CustomDatePicker
                                className="w-[170px]"
                                format={'dd-MM-yyyy'}
                                name={'endDate'}
                                value={endDate}
                                maxDate={new Date()}
                                handleChange={(e) => handleChange(e, "endDate")}
                            /> */}
                            <CustomDatePicker
                                className="w-[170px]"
                                format={'dd-MM-yyyy'}
                                name={'startDate'}
                                value={endDate}
                                handleChange={handleEndDateChange}
                                componentsProps={{
                                    actionBar: { actions: ["clear"] },
                                }}
                                renderInput={(params) => <TextField size="small" InputLabelProps={{
                                }} {...params}/>}
                            />
                        </div>
                    </div>
                    </>
                    :
                    <>
                    <div className="flex items-center">
                    <label className="whitespace-nowrap">Employee Name</label>
                        <Autocomplete
                            id="free-solo-demo"
                            className="mb-16 w-[200px]"
                            placeholder="Employee Name"
                            value={byemployee}
                            freeSolo
                            onChange={(event,value)=>handleEmployeeChange(event, value)}
                            options={employee.map((option) => option.employeeName)}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </div>
                    </>
                }
                {/* <Button
                    variant="contained"
                    color="warning"
                    onClick={handleSearch}
                // disabled={disabled}
                >
                    Search
                    <FuseSvgIcon>heroicons-outline:search-circle</FuseSvgIcon>
                </Button> */}
            </>
        )
    }






    return (
        <>
            <ListPageHeader
                componentName="Attendance"
                onBtExport={onBtExport}
                headerInputFields={headerInputFields()}
                handlePurge={handlePurge}
                addPageLink="/addAttendance"
                pageName="Attendance List"
                error={error}
                deleteDisable={deleteDisable}
                successMsg={successMsg}
                snackState={snackState}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    saveGridStateName={'attendance'}
                />
            </div>
        </>
    )
}

export default Attendance